import palette from './palette';
import overrides from './overrides';
import typography from './typography';
var defaultThemeValues = {
    palette: palette,
    overrides: overrides,
    typography: typography,
};
export default defaultThemeValues;
